/* eslint-disable react/jsx-props-no-spreading */
import queryString from 'query-string';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import CreativesForm from '../components/Creatives/CreativesForm';

function ClientsAdvertisersFormPage() {
  const {
    advertiserId,
    creativeId,
  } = useParams();

  const location = useLocation();
  const qs = queryString.parse(location.search);
  const {
    adGroupId,
    targetedCreativeId,
    productId,
    contractId,
  } = qs;

  return (
    <CreativesForm
      id={Number(creativeId)}
      advertiserId={Number(advertiserId)}
      adGroupId={Number(adGroupId)}
      targetedCreativeId={Number(targetedCreativeId) || undefined}
      productId={Number(productId) || undefined}
      contractId={Number(contractId) || undefined}
    />
  );
}

export default ClientsAdvertisersFormPage;
